
import { Base } from '../base-component';

import './testimonials.component.scss';

export class Testimonials extends Base {

	constructor(element: Element) {
		super(element);
	}

	init() {}

	bindEvents() {}

}



// WEBPACK FOOTER //
// ./components/testimonials/testimonials.component.ts